import styled from 'styled-components';
import { VerticalTabWrapper, Tab, TabText } from '../VerticalTab/styles';

export const TrialPanelWrapper = styled(VerticalTabWrapper)`
  background-color: ${({ theme }) => theme.colors.guidePurple};
  top: 256px;
  height: calc(100% - 256px);
`;

export const TrialPanelTab = styled(Tab)`
  background-color: ${({ theme }) => theme.colors.guidePurple};
  top: 256px;
  right: 0;
  width: 50px;
  height: 80px;
  text-align: center;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  border: 2px solid ${({ theme }) => theme.colors.headerGrey};
  border-right: none;

  ${TabText} {
    writing-mode: initial;
    text-orientation: initial;
    margin-top: 5px;
    padding: 0;
  }
`;

export const TrialDays = styled.div`
  border: 2px solid ${({ theme }) => theme.colors.buttonGreenFront};
  color: ${({ trialEnd, theme }) => (trialEnd ? theme.colors.buttonGreenFront : theme.colors.standardTextGrey)};
  background-color: ${({ trialEnd, theme }) => (trialEnd ? theme.colors.white : theme.colors.transparent)};
  height: 32px;
  width: 32px;
  border-radius: 50%;
  font-family: ${({ theme }) => theme.fonts.roboto};
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
`;
